import { useEffect, useState } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { CommonDestinations, IResDashboard } from '@/types/parcel/dashboard';

import { useDate } from '../Context/DateContext';

interface StateData {
  data: CommonDestinations['commonDestinations'] | null;
  isLoading: boolean;
  isError: boolean;
}

const colorsMap = {
  red: '#2e4515',
  orange: '#5a8629',
  yellow: '#85c440',
  green: '#c7e4a8',
  normal: '#e1e1e1',
};

const useFrequentlyStates = () => {
  const { selectedDate } = useDate();
  const [data, setData] = useState<StateData>({
    data: null,
    isLoading: true,
    isError: false,
  });

  const getBreakdownData = async () => {
    const http = initializeHttpProvider();
    try {
      const response = await http.dashboard.commonDestinations(selectedDate);
      setData({
        data: (response as IResDashboard<CommonDestinations>).data.commonDestinations.sort(
          (a, b) => b.count - a.count,
        ),
        isLoading: false,
        isError: false,
      });
    } catch {
      setData({ data: null, isLoading: false, isError: true });
    }
  };

  useEffect(() => {
    getBreakdownData();
  }, [selectedDate]);

  const getColor = (estado: { name: string; id: string; path: string; objKey?: string }) => {
    if (!data.data) {
      return colorsMap['normal'];
    }

    const stateIndex = data.data.findIndex((item) => item.state === estado?.name);

    if (stateIndex === 0) return colorsMap['red'];
    if (stateIndex === 1) return colorsMap['orange'];
    if (stateIndex === 2) return colorsMap['yellow'];
    if (stateIndex >= 3 && stateIndex <= 9) return colorsMap['green'];
    return colorsMap['normal'];
  };

  const calculatePercentage = (value: number) => {
    const total =
      data.data?.reduce((acc, objeto) => {
        return acc + objeto.count;
      }, 0) || 0;
    return ((value / total) * 100).toFixed(1);
  };

  return {
    data,
    getColor,
    calculatePercentage,
  };
};

export default useFrequentlyStates;
